angular.module('iw.frontyard.error')
    .service('PublicErrorManager', function ($q) {
        return {
            handleException: function (exception, cause) {
                if (isRavenDefined()) {
                    Raven.captureException(exception, {
                        level: 'error',
                        logger: 'javascript',
                        tags: {application: 'frontyard'},
                        extra: {
                            cause: cause,
                            message: extractMessage(exception)
                        }
                    });
                }
            },
            responseError: function (response) {
                if (isRavenDefined()) {
                    let url = response.config.url;
                    let message = response.status + ' ' + response.statusText + ' ' + response.config.url;

                    Raven.captureMessage(message.substr(0, 30), {
                        level: extractLevel(response),
                        logger: 'javascript',
                        tags: {application: 'frontyard'},
                        extra: {
                            status: response.status,
                            statusText: response.statusText,
                            url: url,
                            request: {
                                method: response.config.method,
                                headers: response.config.headers
                            }
                        }
                    });
                }

                return $q.reject(response);
            }
        };

        function extractLevel(response) {
            if (response.status >= 500) {
                return 'fatal';
            }

            return 'error';
        }

        function extractMessage(exception) {
            if (exception && exception.message) {
                return exception.message;
            }

            return exception;
        }

        function isRavenDefined() {
            return angular.isDefined(Raven)
                && angular.isFunction(Raven.isSetup)
                && Raven.isSetup();
        }
    });